import {IProps as IButtonProps} from 'components/Button';
import React, {FC} from 'react';
import {IProductShort} from 'modules/products/types';
import {ButtonNew} from 'components/ButtonNew';

interface IProps extends IProductShort, Pick<IButtonProps, 'isNotAdaptive' | 'textClassName'> {
    className?: string;
    href?: string;
}

export const SubscriptionButton: FC<IProps> = ({className, href, textClassName}) => {
    return (
        <ButtonNew
            className={className}
            data-prevent-default-marker={true}
            data-stop-propagation-marker={true}
            href={href}
            isStretched={true}
            theme={'outline'}
            textClassName={textClassName}
            variants={{DT: 'medium', TB: 'medium', MB: 'small'}}
        >
            Узнать о&nbsp;наличии
        </ButtonNew>
    );
};
